import { useMutation, useQueryClient } from "@tanstack/react-query";
import { contextsKeys } from "Auth/Api/Queries/Context/useGetContextsQuery";
import {
  type AddRoleRequest,
  type AddRoleResult,
  postIdentitiesRolesMerchant,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: (result: AddRoleResult) => void;
  onError?: (error: unknown) => void;
};

export const useAddMerchantRoleMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (request: AddRoleRequest) => postIdentitiesRolesMerchant(request),
    ),
    onSuccess: (result: AddRoleResult) => {
      queryClient.invalidateQueries({ queryKey: contextsKeys.all });
      onSuccess?.(result);
    },
    onError,
  });
};
